import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeNameOfDish: (value: string) => void;
}

export const NameDishInput: React.FC<IProps> = React.memo(({ changeNameOfDish }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterDishName') }], [t]);

	return (
		<FormInput
			testId="NameDishInput"
			name="nameOfDish"
			label="dishNameLabel"
			onChange={changeNameOfDish}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
});
